import { CHANGE_VISIBILITY_CHATICON } from '../constants/chatIcon';

export const initialState = {
  showChatIcon: true,
};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export function chatIcon(state = initialState, action) {
  switch (action.type) {
    case CHANGE_VISIBILITY_CHATICON: {
      if (action.payload.showIcon)
        return {
          ...state,
          showChatIcon: true,
        };
      return {
        ...state,
        showChatIcon: false,
      };
    }

    default:
      return state;
  }
}
